import React from 'react'
import Icon from '@components/atoms/Icon'
import Button from '@components/atoms/Button'

interface PopupProps {
  message: string
  subMessage?: string | null
  onClose: () => void
  onConfirm?: () => void
  showConfirmButton?: boolean
}

const InfoPopup: React.FC<PopupProps> = ({ message, subMessage, onClose, onConfirm, showConfirmButton = true }) => (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-md py-5 px-10 relative scale-in">
      <button
        type="button"
        className="absolute top-3 right-3 text-black text-opacity-80 hover:text-opacity-100"
        onClick={onClose}
        aria-label="Close"
      >
        <Icon name="close" className="w-5 h-5" />
      </button>

      <div className="text-center">
        <h3 className="text-black h3 mb-3">{message}</h3>
        {subMessage && <p className="body-sm text-black text-opacity-80 mb-4">{subMessage}</p>}
        <div className="flex items-center justify-center gap-4 mt-4">
          {showConfirmButton && (
            <Button
              mode="button"
              className="min-w-22.5 min-h-7.5 max-h-7.5 button--sm"
              buttonText="Got it"
              onClick={onConfirm || onClose}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)

export default InfoPopup
